import { t as coreT } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { Form, Formik } from 'formik';
import { DeviceDto } from 'modules/core/supabase/tables/device';
import React from 'react';
import UDFormInput from 'ud-form/components/input';
import { UDModalDirtyGuard } from 'ud-form/components/modal-dirty-guard';
import { UDButton } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';
import * as yup from 'yup';

export interface DeviceFormValues {
  name: string;
}

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .min(1, () => coreT`Обязательное поле`)
    .required(() => coreT`Обязательное поле`),
});

interface DeviceFormProps {
  initValue?: DeviceDto;
  onSubmit: (values: DeviceFormValues) => Promise<void>;
}

const DeviceForm = React.memo(function DeviceForm(props: DeviceFormProps) {
  const { initValue, onSubmit } = props;
  const { t } = useLingui();

  const initialValues: DeviceFormValues = {
    name: initValue?.name ?? '',
  };

  const isEdit = Boolean(initValue);

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
      {(formProps) => (
        <Form className="w-[454px]">
          <UDModalDirtyGuard />
          <Modal.Body className="flex flex-col gap-4">
            <UDFormInput name="name" placeholder={t`Название`} errorVisible />
          </Modal.Body>
          <Modal.Footer>
            <UDButton variant="primary" type="submit" loading={formProps.isSubmitting} stretch disabled={!formProps.dirty}>
              {isEdit ? <Trans>Сохранить</Trans> : <Trans>Создать</Trans>}
            </UDButton>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
});

export default DeviceForm;
